import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import CustomInput from "../../Common/CustomInput/CustomInput";
import Spinner from "../../Layouts/Spinner";
import { useNavigate } from "react-router-dom";
import { addReferalUser } from "../../../redux/referals/actions";

const addreferalSchema = () =>
  yup.object({
    first_name: yup
      .string()
      .required("This field is required")
      .min(2, "Enter at least two character")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),

    last_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    mobile_number: yup
      .string()
      .min(9, "minimum of 9 numbers required")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),
    email_id: yup
      .string()
      .email("Enter a valid email address")
      .test(
        "optional-email-validation",
        "Enter a valid email address",
        (value) =>
          !value ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ),
  });

const Addreferal = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      mobile_number: "",
      email_id: "",
    },
    validationSchema: addreferalSchema(),
    onSubmit: (values) => handleAddReferalUser(values),
  });

  const handleAddReferalUser = (values) => {
    setIsLoading(true);
    addReferalUser(values, setIsLoading)
      .then((res) => {
        if (res.data.status) {
          navigate(`/referallist/updateuser/${res.data.response.user_id}`, {
            replace: true,
          });
          formik.resetForm();
        }
      })
      .catch((e) => console.log("arr referal error", e.message));
  };

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  return (
    <div className="p-3 category-wrapper">
      <h3 className="pb-3">Add Customer Referral</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-3 from-group">
            <label>First Name</label>
            <CustomInput
              name="first_name"
              id="first_name"
              type="text"
              placeholder="Enter First Name"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              errors={formik.errors}
              touched={formik.touched}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-md-3 from-group">
            <label>Last Name</label>
            <CustomInput
              name="last_name"
              id="last_name"
              type="text"
              placeholder="Enter Last Name"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              errors={formik.errors}
              touched={formik.touched}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>Mobile Number</label>
              <PhoneInput
                country="sa"
                // value={formik.values.mobile_number}
                value={
                  formik?.values.country_code
                    ? `${formik.values.country_code}${formik.values.mobile_number}`
                    : ""
                }
                onChange={(phone, data) => handleCountryCode(phone, data)}
                onBlur={() => formik.setFieldTouched("mobile_number", true)}
              />
            </div>
            {formik.touched.mobile_number && formik.errors.mobile_number && (
              <p className="error-message">{formik.errors.mobile_number}</p>
            )}
          </div>
          <div className="col-md-3 from-group">
            <label>Email Address (optional) </label>
            <CustomInput
              name="email_id"
              id="email_id"
              type="email"
              placeholder="Enter Email Address"
              value={formik.values.email_id}
              onChange={formik.handleChange}
              errors={formik.errors}
              touched={formik.touched}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-md-12 text-center my-3 d-flex align-items-center justify-content-center col-gap-10">
            <button
              className="submit-btn"
              disabled={isLoading}
              onClick={() => navigate(-1)}
              type="button"
              style={{ marginRight: "20px" }}
            >
              Back
            </button>
            <button className="submit-btn" disabled={isLoading} type="submit">
              {!isLoading ? "Add Customer" : <Spinner />}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Addreferal;
